import { BseDto } from "../../autogen/bff-api";

export const eventIsLive = (event: BseDto): boolean => {
  return event.status === "Published" || event.status === "DeadlineHasPassed";
};
